export const FIND_EDOK_FORM_REQUEST = 'FIND_EDOK_FORM_REQUEST';

export const findEdokFormRequest = ( id ) => ({
    type: FIND_EDOK_FORM_REQUEST,
    payload: { id }
});
